// The 2027 season as Musette shows it, until the racing feed lands in January. Only dates and
// stages already confirmed in the Cycling project's notes (24 October 2026); nothing guessed.
// Kyle's own rides sit on the same line in amber, because they are the season that matters to him.
export type Stage = { date: string; from: string; to: string; km?: number; note?: string };
export type RaceEvent = {
  id: string; name: string; short: string; from: string; to: string; where?: string;
  kind: "grand" | "race" | "you"; color: string; line: string; going?: string; stages?: Stage[];
};

export const SEASON: RaceEvent[] = [
  { id: "tdu", name: "Santos Tour Down Under", short: "TDU", from: "2027-01-19", to: "2027-01-24", where: "Adelaide", kind: "race", color: "var(--race-other)", line: "The season opener. The live feed starts here." },
  { id: "giro", name: "Giro d'Italia", short: "Giro", from: "2027-05-08", to: "2027-05-30", kind: "grand", color: "var(--race-giro)", line: "Three weeks in Italy, finishing a fortnight before you ride to Paris." },
  { id: "paris-ride", name: "Your ride: Manchester to Paris", short: "Paris", from: "2027-06-12", to: "2027-06-15", kind: "you", color: "var(--accent)", line: "649 km in four days, 4,640 m of climbing. Day 1 is the long one: 207 km.",
    stages: [
      { date: "2027-06-12", from: "Manchester", to: "Wellingborough", km: 207 },
      { date: "2027-06-13", from: "Wellingborough", to: "London", km: 146 },
      { date: "2027-06-14", from: "London", to: "Newhaven", km: 103 },
      { date: "2027-06-15", from: "Dieppe", to: "Paris", km: 193 },
    ] },
  { id: "tour", name: "Tour de France", short: "Tour", from: "2027-07-02", to: "2027-07-25", where: "Starts in Edinburgh", kind: "grand", color: "var(--race-tour)", line: "Three stages in Britain, then France. The final is 116 km into Paris on Sunday 25 July.", going: "Watching all three UK stages",
    stages: [
      { date: "2027-07-02", from: "Edinburgh", to: "Carlisle", km: 183 },
      { date: "2027-07-03", from: "Keswick", to: "Liverpool", km: 223, note: "Trough of Bowland, Jubilee Tower" },
      { date: "2027-07-04", from: "Welshpool", to: "Cardiff", km: 223 },
      { date: "2027-07-25", from: "The final", to: "Paris", km: 116, note: "Riding there or the train: open" },
    ] },
  { id: "femmes", name: "Tour de France Femmes", short: "Femmes", from: "2027-07-30", to: "2027-08-01", where: "Starts in Leeds", kind: "grand", color: "var(--race-tour)", line: "Through Manchester and over Snake Pass, 6.1 km at 5.7%.", going: "In reach from home",
    stages: [
      { date: "2027-07-30", from: "Leeds", to: "Manchester" },
      { date: "2027-07-31", from: "Manchester", to: "Sheffield", note: "Over Snake Pass" },
      { date: "2027-08-01", from: "London", to: "London" },
    ] },
  { id: "mallorca", name: "Your fortnight: Mallorca", short: "Mallorca", from: "2027-08-01", to: "2027-08-15", kind: "you", color: "var(--accent)", line: "Sa Calobra, Puig Major, Formentor. Flights and the bike box still to book." },
  { id: "vuelta", name: "Vuelta a España", short: "Vuelta", from: "2027-09-04", to: "2027-09-26", kind: "grand", color: "var(--race-vuelta)", line: "The last of the three." },
];

/** Snapshot, 24 October 2026: Il Lombardia (procyclinguk.com), transfers (Cycling Weekly). */
export const LAST_RESULT = { race: "Il Lombardia", date: "2026-10-10", rows: [
  ["1", "Paul Seixas", "Decathlon CMA CGM", "Solo, from the Civiglio"],
  ["2", "Enric Mas", "Movistar", "+0:48"],
  ["3", "Giulio Ciccone", "Lidl-Trek", "+1:05"],
] };
export const TRANSFERS = [
  ["Filippo Ganna", "Netcompany-Ineos", "Lidl-Trek"],
  ["Felix Gall", "Decathlon CMA CGM", "Lidl-Trek"],
  ["Mikel Landa", "Soudal Quick-Step", "Euskaltel-Euskadi"],
  ["Ethan Hayter", "Soudal Quick-Step", "Pinarello Q36.5"],
];
